import i18n, { SUPPORTED_LOCALES, getLocale as inferLocale } from './index'

/**
 * 在非 Vue 组件中使用国际化
 * @param {string} key - 翻译的 key
 * @param {object} values - 插值参数
 * @returns {string} 翻译后的文本
 */
export function t(key, values) {
  return i18n.t(key, values)
}

/**
 * 获取当前语言
 * @returns {string} 当前语言代码 (如 'zh', 'en')
 */
export function getLocale() {
  return i18n.locale
}

/**
 * 设置语言
 * @param {string} locale - 语言代码 (如 'zh', 'en')
 */
export function setLocale (locale) {
  i18n.locale = locale
  localStorage.setItem('locale', locale)
  localStorage.setItem('locale_user_set', '1')
}

/**
 * 恢复跟随系统语言：清除手动设置并重新按浏览器语言推断
 */
export function setFollowSystem () {
  localStorage.removeItem('locale')
  localStorage.removeItem('locale_user_set')
  i18n.locale = inferLocale()
}

/**
 * 获取当前语言的母语名称
 * @param {string} followSystemText - 跟随系统时的展示文案
 * @returns {string} 母语名称
 */
export function getCurrentLanguageName (followSystemText) {
  if (localStorage.getItem('locale_user_set') !== '1') {
    return followSystemText
  }
  const item = SUPPORTED_LOCALES.find(function (l) { return l.locale === i18n.locale })
  return item ? item.name : followSystemText
}

/**
 * 显示国际化提示
 * @param {string} key - 翻译的 key
 * @param {object} values - 插值参数
 */
export function showAlert(key, values) {
  alert(t(key, values))
}



// WEBPACK FOOTER //
// ./src/i18n/helpers.js